const ActiveStatus = (bool) => {
    return bool ? "Active" : "Inactive";
};

export default ActiveStatus;
